<template>
	<v-card class="pa-0 mt-3" :style="dialog ? 'margin-top: 15px !important' : ''">
		<div class="font-size16 text-left pa-2 font-weight-bold">
			{{ $t('phq-table-header') }}
		</div>
		<v-data-table
			:style="dialog ? 'border: 1px solid #e1dce8' : 'border-top: 1px solid #ddd'"
			hide-default-footer
			:headers="headers"
			:items="items"
			:item-class="itemClass"
			dense />
	</v-card>
</template>

<script>
export default {
	props: ['dialog', 'totalScore'],
	computed: {
		indexOfRow () {
			if (this.totalScore >= 0 && this.totalScore <= 4) {
				return 0;
			} else if (this.totalScore >= 5 && this.totalScore <= 9) {
				return 1;
			} else if (this.totalScore >= 10 && this.totalScore <= 14) {
				return 2;
			} else if (this.totalScore >= 15 && this.totalScore <= 19) {
				return 3;
			} else if (this.totalScore >= 20 && this.totalScore <= 27) {
				return 4;
			} else {
				return -1; // Out of range
			}
		},
		headers () {
			return [
				{ text: this.$t('phq-header-1'), align: 'start', value: 'score' },
				{ text: this.$t('phq-header-2'), value: 'severity' },
				{ text: this.$t('phq-header-3'), value: 'actions' },
			];
		},
		items () {
			return [
				{ score: '0 - 4', severity: this.$t('phq-item-1'), actions: this.$t('phq-item-description-1') },
				{ score: '5 - 9', severity: this.$t('phq-item-2'), actions: this.$t('phq-item-description-2') },
				{ score: '10 - 14', severity: this.$t('phq-item-3'), actions: this.$t('phq-item-description-3') },
				{ score: '15 - 19', severity: this.$t('phq-item-4'), actions: this.$t('phq-item-description-4') },
				{ score: '20 - 27', severity: this.$t('phq-item-5'), actions: this.$t('phq-item-description-5') },
			];
		},
	},
	methods: {
		itemClass (item, index) {
			// Prefer provided index; fallback to lookup when not available
			const idx = typeof index === 'number' ? index : this.items.findIndex((i) => i.score === item.score);
			return idx === this.indexOfRow ? 'selected-row' : '';
		},
	},
};
</script>

<style scoped>
.v-data-table {
	border-radius: 0;
	border: 0;
	border-top: 1px solid #ddd;
}
.v-toolbar-title {
	font-weight: bold;
}
</style>
